import { type VFC } from 'react'

import './TrackingPixel.scss'

interface TrackingPixelProps {
  src: string
}

const TrackingPixel: VFC<TrackingPixelProps> = ({ src }) => (
  <img className="Tp" src={src} alt="" width="1" height="1" />
)

export default TrackingPixel
